/**
 * Intake (semester) dropdown options.
 *
 * The `_id` is what gets sent to the API as `intake`, and the backend matches it
 * against Student.intake, which is stored space-separated and lowercase
 * ("fall 2026"). A previous version of this list used "fall-2026", which matched
 * zero students and made every report come back empty — so both the Dashboard
 * and the Analytics page build their options from here rather than each rolling
 * their own format.
 */
const SEASONS = [
  { id: "fall", name: "Fall" },
  { id: "spring", name: "Spring" },
];

export const buildIntakeOptions = ({ yearsBack = 2, yearsForward = 2 } = {}) => {
  const currentYear = new Date().getFullYear();
  const options = [];

  for (let year = currentYear - yearsBack; year <= currentYear + yearsForward; year += 1) {
    SEASONS.forEach((season) => {
      options.push({
        _id: `${season.id} ${year}`,
        title: `${season.name} ${year}`,
      });
    });
  }

  // Newest first
  return options.reverse();
};

/** Normalises an intake from any source ("Fall-2026", "FALL 2026") to "fall 2026". */
export const normaliseIntake = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, " ");

/** Human label for an intake value, e.g. "fall 2026" -> "Fall 2026". */
export const formatIntakeLabel = (value) => {
  const normalised = normaliseIntake(value);
  if (!normalised) return "";

  return normalised
    .split(" ")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

export default buildIntakeOptions;
